import styled from "styled-components"
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Form, Segment } from "semantic-ui-react"
import { FormTextAreaFormField, LinkText, SubmitCancelButtons } from "elements"
import React, { useEffect, useState } from "react"
import { FlexColumn, FlexRow, FlexRowBetween, ImageContainer, LoaderBar } from "components"
import { Images } from "assets"
import { useNotification } from "hooks"
import { CommentsService, DateFormat, DateUtility, DefaultText, FormErrorText } from "utility"
import { useAuth } from "context"
import { useTabletAndBelowMediaQuery } from "layout"

const CommentsContainer = styled(Segment)`
`

const CommentSchema = yup.object().shape({
    CommentContent: yup.string().trim(FormErrorText.SpacesNotAllowed).strict().required('Comment is required'),
})

const CommentBox = ({ ele, onEdit, onRemove, isMobile }) => (<Segment className="p-2">
    <FlexRowBetween className={`${isMobile && "flex-column"}`}>
        <FlexRow className="d-flex align-items-center">
            <ImageContainer height="30px" width="30px" round src={Images.User} alt="" />
            <FlexColumn className="ms-3">
                <p className="my-0">{ele?.CommentContent}</p>
                <h6 className="my-0">{DateUtility.dateToLocalISO(new Date(ele?.CommentDate), DateFormat.dateTime)}</h6>
            </FlexColumn>
        </FlexRow>
        <FlexRow className={`${isMobile && "justify-content-end"}`}>
            <LinkText onClick={() => onEdit(ele)}>Edit</LinkText>
            <LinkText onClick={() => onRemove(ele)} className="ms-3">Delete</LinkText>
        </FlexRow>
    </FlexRowBetween>
</Segment>)

export const CommentsList = ({ templateId, list, loading, refetch }) => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({ resolver: yupResolver(CommentSchema) })
    const { errorToast } = useNotification()
    const [processing, setProcessing] = useState("")
    const { user } = useAuth()
    const isMobile = useTabletAndBelowMediaQuery()
    useEffect(() => {
        reset({})
    }, [])

    const onSubmit = async (formData) => {
        setProcessing("")
        try {
            await CommentsService.addUpdate({
                ...formData,
                CommentType: 2,
                UserId: formData?.UserId || user.unique_id,
                CommentId: formData?.CommentId || 0,
                TemplateId: formData?.TemplateId || templateId,
            })
        } catch {
            errorToast(DefaultText.defaultError)
        } finally {
            reset({ CommentContent: "" })
            refetch()
        }
    }

    const onEdit = (ele) => {
        reset({
            ...ele,
        })
    }
    const onRemove = async (ele) => {
        try {
            await CommentsService.remove(ele.CommentId)
        } catch {
            errorToast(DefaultText.defaultError)
        } finally {
            refetch()
        }
    }

    return (<CommentsContainer raised>
        <Form noValidate>
            <Form.Field>
                <FormTextAreaFormField
                    control={control}
                    label="Comments"
                    name="CommentContent"
                    placeholder="Please enter comment here"
                    errors={errors?.CommentContent}
                    defaultValue=""
                    rows={3}
                />
                <SubmitCancelButtons
                    onSubmit={handleSubmit(onSubmit)}
                    cancelText="Reset"
                    onCancel={() => reset({ CommentContent: "" })}
                    loading={processing}
                />
            </Form.Field>
        </Form>
        {loading && !list.length && <LoaderBar />}
        {list?.map(ele => (<React.Fragment key={ele.CommentId}><CommentBox onEdit={onEdit} onRemove={onRemove} ele={ele} isMobile={isMobile} /></React.Fragment>))}
    </CommentsContainer>)
}